(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ModelosdeimpresoraDialogController', ModelosdeimpresoraDialogController);

    ModelosdeimpresoraDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Modelosdeimpresora', 'Pv'];

    function ModelosdeimpresoraDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Modelosdeimpresora, Pv) {
        var vm = this;

        vm.modelosdeimpresora = entity;
        vm.clear = clear;
        vm.save = save;
        vm.pvs = Pv.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.modelosdeimpresora.id !== null) {
                Modelosdeimpresora.update(vm.modelosdeimpresora, onSaveSuccess, onSaveError);
            } else {
                Modelosdeimpresora.save(vm.modelosdeimpresora, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:modelosdeimpresoraUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
